export const convertNumbers = (number) => {
    const persianNumbers = ["۰", "۱", "۲", "۳", "۴", "۵", "۶", "۷", "۸", "۹"];
    if (number || number === 0) {
        var str = number.toString();
        for (var i = 0; i < 10; i++) {
            str = str.replace(new RegExp(i, 'g'), persianNumbers[i]);
        }
        return str;
    }

    return number;
}

export const RconvertNumbers = (number) => {
    const persianNumbers = ["۰", "۱", "۲", "۳", "۴", "۵", "۶", "۷", "۸", "۹"];
    if (number || number === 0) {
        var str = number.toString();
        for (var i = 0; i < 10; i++) {
            str = str.replace(new RegExp(persianNumbers[i], 'g'), i);
        }
        return str;
    }
    return number;
}